<script setup>
import { ref, watchEffect } from 'vue';
import { useColorMode, useCycleList } from '@vueuse/core';

// Color mode
const mode = useColorMode({
  emitAuto: true,
  modes: {},
});

const themes = ref({
  light: { tooltip: 'Light theme', icon: 'icon-[ph--sun]' },
  dark: { tooltip: 'Dark theme', icon: 'icon-[ph--moon]' },
  auto: { tooltip: 'System theme', icon: 'icon-[ph--monitor]' },
});

const { state, next } = useCycleList(Object.keys(themes.value), {
  initialValue: mode,
});

watchEffect(() => (mode.value = state.value));
</script>

<template>
  <Button
    text
    @click="next()"
    severity="secondary"
    class="-my-2 mr-4 !p-1.5"
    v-tooltip.bottom="themes[state].tooltip"
  >
    <i :class="themes[state].icon" class="text-2xl" />
  </Button>
</template>
